/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12GradReqThresholdApi {
  async DeserializeProps(json : string) : Promise<sis.GradReqThresholdData> {
    return await componentApi.call('sis', 'sis-k12-gradreq-threshold', 'K12GradReqThresholdApi', 'DeserializeProps', {
      json,
    });
  }
}
export default new K12GradReqThresholdApi()
